<template>
  <div>
    <Head title="Packed Orders" />
    <h1 class="mb-8 text-3xl font-bold">Packed Orders</h1>
    <div class="flex items-center justify-between mb-6">
      <search-with-dropdown-filter v-model="search.search" class="mr-4 w-full max-w-md">
        <label class="block text-gray-700">Channel:</label>
        <select v-model="search.channel" class="form-select mt-1 w-full">
          <option :value="null">-All Channels-</option>
          <option v-for="item in channels" :key="item.id" :value="item.name">{{ item.name }}</option>
        </select>
      </search-with-dropdown-filter>
      <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
      <div>
        <a v-if="isBulk" class="btn-orange" href="#" @click="openModal(bulkOptions)">
          <span>Create </span>
          <span class="hidden md:inline">&nbsp;a Delivery Run</span>
        </a>
      </div>
    </div>
    <div class="flex items-center justify-between mb-6">
      <span v-if="isBulk && queueVolume"><strong>Total Volume: {{ queueVolume.volume }}</strong></span>
      <a
        v-if="(orders.data.length > 0 && url())"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/packed-orders/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">#</th> 
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Date Picked</th>
          <th class="pb-3 pt-3 px-3">Type</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer</th>
          <th class="pb-3 pt-3 px-3">Contact</th> 
          <th class="pb-3 pt-3 px-3">Alternative Contact</th> 
          <th class="pb-3 pt-3 px-3">Physical Address</th>
          <th class="pb-3 pt-3 px-3">Region</th>
          <th class="pb-3 pt-3 px-3">Zone</th>
          <th class="pb-3 pt-3 px-3">City</th>
          <th class="pb-3 pt-3 px-3">Total CBM</th>
          <th class="pb-3 pt-3 px-3">Waybill Number</th>
          <th class="pb-3 pt-3 px-3 text-end" />
        </tr>
        <tr v-for="list in orders.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td
            v-if="user.group_permissions.includes('create_delivery_run')
              || user.per_user_permissions.includes('create_delivery_run')
              || user.role === 'admin'"
            class="border-t pl-2"
          >
            <input
              :id="`item-${list.id}`"
              type="checkbox"
              :value="list.id"
              class="flex items-center px-3 py-3 focus:text-orange-500 ml-2"
              @click="buildBulk(list)"
            />
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.date_closed }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.type }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.order_no }}
            </Link>
          </td>
          <!--<td class="border-t">
            <Link class="flex items-center justify-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.quantity }}
            </Link>
          </td>-->
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.contact }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.alternative_contact }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.physical_address }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.region }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.zone }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.city }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.total_cbm }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/dispatches/orders/${list.id}/details`" title="">
              {{ list.waybill_no }}
            </Link>
          </td>
          <td class="w-px border-t">
            <a :href="`/dispatches/orders/${list.id}/details`" class="flex items-center justify-end pr-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="14">No data found</td>
        </tr>
      </table>
    </div>
    <br>
    <span v-if="isBulk && queueVolume" class="mt-3"><strong>Total Volume: {{ queueVolume.volume }}</strong></span>
    <pagination class="mt-6" :links="orders.links" />
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-12 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Delivery Assistant.</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="w-full lg:w-full pb-2 pr-6">
                <multiselect
                  id="delivery_assistant_id"
                  v-model="selectedDeliveryAssistant"
                  placeholder="Search Delivery Assistants"
                  :options="delivery_assistants"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.delivery_assistant_id"
                  :style="form.errors.delivery_assistant_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                  @search-change="onSearchDeliveryAssistantChange"
                  @input="onSelectedDeliveryAssistant"
                />
                <div v-if="form.errors.delivery_assistant_id" class="form-error">{{ form.errors.delivery_assistant_id }}</div>
              </div>
              <div class="w-full lg:w-full pb-2 pr-6">
                <multiselect
                  id="provider_id"
                  v-model="selectedLogisticProvider"
                  placeholder="Search Logistic Provider"
                  :options="providers"
                  :close-on-select="true"
                  :searchable="true"
                  :error="form.errors.provider_id"
                  :style="form.errors.provider_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                  @search-change="onSearchLogisticProviderChange"
                  @input="onSelectedLogisticProvider"
                />
                <div v-if="form.errors.provider_id" class="form-error">{{ form.errors.provider_id }}</div>
              </div>
              <div class="w-full lg:w-full pb-2 pr-6">
                <text-input
                  v-model="form.plate_number"
                  class="pb-2"
                  :error="form.errors.plate_number"
                  placeholder="Plate Number"
                />
                <div v-if="form.errors.plate_number" class="form-error">{{ form.errors.plate_number }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submit">
                Assign
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchWithDropdownFilter from '@/Shared/SearchWithDropdownFilter'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'
import TextInput from '@/Shared/TextInput'
import DateRange from '@/Shared/DateRange'
import axios from 'axios'
      
export default {
  components: {
    Head,
    Link,
    SearchWithDropdownFilter,
    Pagination,
    Multiselect,
    TextInput,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    delivery_assistants: Object,
    providers: Object,
    channels: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        orders: null,
        order_ids: null,
        delivery_assistant_id: null,
        provider_id: null,
        plate_number: null,
      }),
      search: {
        search: this.filters.search,
        channel: this.filters.channel,
        dateValue: this.filters.dateValue,
      },
      isBulk: false,
      bulkOptions: [],
      isOpen: false,
      selectedDeliveryAssistant: null,
      queueVolume: null,
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/dispatches/picked-orders', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    buildBulk(order) {
      const inpt = `#item-${order.id}`
      if ($(inpt).is(':checked')) {
        // if (this.bulkOptions.length === 0) {
        this.bulkOptions.push({ id: $(inpt).val() })
        //} else {
        //  $(inpt).prop('checked', false)
        //  alert('You are not allowed to select more than one orders for the same DR.')
        //}
      } else {
        const selectedItem = $(inpt).val()
        const selected = { id: selectedItem }
        const items = this.bulkOptions.filter((item) => item.id !== selected.id)
        this.bulkOptions = items
      }
      if (this.bulkOptions.length > 0) {
        this.isBulk = true
      } else {
        this.isBulk = false
      }
      this.form.order_ids = this.bulkOptions
      axios.post(`/dispatch/packed-orders/volume/search`, this.form).then(response => {
        this.queueVolume = response.data
      })
    },
    submit(e) {
      e.preventDefault()
      this.form.post('/dispatches/picked-orders', {
        onSuccess: () => {
          this.form.reset(
            'delivery_assistant_id',
            'orders',
            'provider_id',
            'plate_number',
          )
          this.orders = null
          this.bulkOptions = null
          this.isBulk = false
          this.isOpen = false
          this.selectedDeliveryAssistant = null
          this.selectedLogisticProvider = null
        }
      })
    },
    openModal(data) {
      this.details = []
      this.isOpen = true
    },
    closeModal() {
      this.isOpen = false
      this.selectedDeliveryAssistant = null
    },
    onSelectedDeliveryAssistant(delivery_assistant_id, id) {
      this.form.delivery_assistant_id = delivery_assistant_id
      this.selectedDeliveryAssistant = delivery_assistant_id
      this.form.orders = this.bulkOptions
    },
    onSearchDeliveryAssistantChange: throttle(function (location) {
    }),
    onSelectedLogisticProvider(provider_id, id) {
      this.form.provider_id = provider_id
      this.selectedLogisticProvider = provider_id
      // this.form.orders = this.bulkOptions
    },
    onSearchLogisticProviderChange: throttle(function (location) {
    }),
    url() {
      let query = '';
      if (this.search.search) {
        if (query) {
          query += '&';
        }
        query += `search=${this.search.search}`;
      }
      if (this.search.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.search.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
      